<section class="fb" role="search">

  <header class="fb__head">
    <h2 class="fb__title">
      <i class="fa-solid fa-filter" aria-hidden="true"></i>
      {{ titleKey() | translate }}
      @if (hasActiveFilters()) {
        <span class="fb__count">
          {{ 'FILTERS.ACTIVE_COUNT' | translate: { count: activeCount() } }}
        </span>
      }
    </h2>

    <div class="fb__head-end">
      @if (hasActiveFilters() && showCounts()) {
        <span class="fb__results">
          {{ 'FILTERS.RESULT_COUNT' | translate: { shown: resultCount(), total: totalCount() } }}
        </span>
      }

      @if (hasActiveFilters()) {
        <button type="button" class="fb__reset" (click)="onReset()">
          <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
          {{ 'FILTERS.RESET' | translate }}
        </button>
      }
    </div>
  </header>

  <!-- Recherche libre : débouncée, un filtrage par pause de frappe. -->
  @if (searchable()) {
    <div class="fb__search">
      <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
      <input type="search"
             [value]="textDraft()"
             (input)="onText($any($event.target).value)"
             [attr.aria-label]="searchLabelKey() | translate"
             [placeholder]="searchPlaceholderKey() | translate">
    </div>
  }

  <!-- Facettes fournies par l'écran appelant. -->
  <div class="fb__facets">
    <ng-content></ng-content>
  </div>
</section>
